<template>
  <v-card color="lighten-3" elevation="0" rounded="lg">
    <v-card-text :class="{ 'pa-0': noPadding }">
      <v-row class="justify-center">
        <v-col md="6" cols="12" class="d-flex justify-end">
          <v-btn
            block
            color="success"
            :loading="loader.loading('button')"
            size="x-large"
            @click="submit"
          >
            <span>Adquirir {{ $t('entities.ticket', 1) }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { useLoader } from "@/stores/loader";
import CheckoutResult from "@/types/CheckoutResult";
import PaymentData from "@/types/PaymentData";
import PaymentMethod from "@/types/PaymentMethod";
import { useCheckoutStore } from "@/stores/checkout";

interface Props {
  noPadding?: boolean;
  method: PaymentMethod;
}

const props = withDefaults(defineProps<Props>(), {
  noPadding: false,
});

const emit = defineEmits<{
  submit: [];
}>();

const loader = useLoader();
const checkout = useCheckoutStore();

function submit() {
  emit("submit");
}

function validate() {
  return true;
}

async function pay(): Promise<CheckoutResult> {
  const data = {} as PaymentData;

  return await checkout.pay(props.method, data);
}

defineExpose({
  validate,
  pay,
});
</script>
